module.exports = __webpack_public_path__ + "assets/logo.ae0e3388.svg";